export const APPLY_WORKFLOW_LAYOUT_EVENT = 'profase:apply-workflow-layout';
export const PEDIR_MEJORA_LAYOUT_EVENT = 'profase:pedir-mejora-layout';

export function applyWorkflowLayout(nodos: unknown): void {
  if (!Array.isArray(nodos) || nodos.length === 0) return;
  window.dispatchEvent(new CustomEvent(APPLY_WORKFLOW_LAYOUT_EVENT, { detail: { nodos } }));
}

export function pedirMejoraLayout(): void {
  window.dispatchEvent(new CustomEvent(PEDIR_MEJORA_LAYOUT_EVENT));
}

if (typeof window !== 'undefined') {
  window.applyWorkflowLayout = applyWorkflowLayout;
  window.pedirMejoraLayout = pedirMejoraLayout;
}
